import { lazyRouteComponent } from '@tanstack/react-router';
import { ShoppingCart } from 'lucide-react';
import type { WebModule } from '../web-module.ts';

/** Módulo Compras nas telas (catálogo beadev-ai/catalogo). Os textos ficam em `purchases.*`. */
export const webModule: WebModule = {
  id: 'purchases',
  areas: [
    {
      id: 'purchases',
      key: 'purchases.area',
      icon: ShoppingCart,
      groups: [
        {
          key: null,
          items: [
            {
              to: '/purchases',
              key: 'purchases.nav.list',
              icon: ShoppingCart,
              permission: ['purchases.purchase.read', 'purchases.purchase.manage'],
            },
          ],
        },
      ],
    },
  ],
  routes: [
    {
      path: '/purchases',
      component: lazyRouteComponent(() => import('./PurchasesPage.tsx'), 'PurchasesPage'),
    },
  ],
  permissionAreas: [
    {
      id: 'purchases',
      key: 'purchases.area',
      processes: [
        {
          id: 'purchases',
          key: 'purchases.process',
          permissions: ['purchases.purchase.read', 'purchases.purchase.manage'],
        },
      ],
    },
  ],
};
